import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormMedida from './FormMedida';

import getMedidas from '../../../../graphql/querys/otros/getMedidas.graphql';
import insertMedida from '../../../../graphql/mutations/otros/insertMedida.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(insertMedida, {
  name: 'insertMedida',
  options: {
    refetchQueries: [{ query: getMedidas }],
  },
})
class CrearMedida extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      medida: {
        nombre: '',
      },
      step: 0,
      loading: false,
    };

    this.guardarMedida = this.guardarMedida.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarMedida(medida) {
    this.props
      .insertMedida({
        variables: {
          medida,
        },
      })
      .then(res => {
        notification.success({
          message: 'Creacion Correcta',
          description: 'Se ha registrado la nueva medida exitosamente',
        });

        this.props.history.push('/admin/otros/medidas');
      })
      .catch(err => {
        console.log('Error en la creacion de la medida');
        console.log(err);
        errorService(err, medida);

        Modal.error({
          title: 'Error en la creacion de la medida',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Medida</Breadcrumb.Item>
          <Breadcrumb.Item>Crear</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Crear Medida
          </h2>
          <br />
          <div style={estiloContent}>
            <FormMedida
              className="formularios"
              onSubmit={this.guardarMedida}
              onAnterior={() =>
                this.props.history.push('/admin/otros/medidas')
              }
              datos={this.state.medida}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearMedida);
